<template>
	<div class="mySwiper">
		<!-- PC端 -->
		<div class="pc_swiper">
			<div class="swiper-container" v-if="url == 'home'">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in homeList" :key='index'>
						<img :src="imageHttp(item.images) " />
					</div>
					<div class='modular' @click="open()"></div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
			<!-- 产品服务 -->
			<div class="swiper-container" v-if="url == 'product'">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in productList" :key='index' >
						<img :src="imageHttp(item.images) " />
					</div>
					<div class='modular' @click="open()"></div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
			<!-- 渠道合作 -->
			<div class="swiper-container" v-if="url == 'channel '">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in channelList" :key='index' >
						<img :src="imageHttp(item.images) " />
					</div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
			<!-- 关于我们 -->
			<div class="swiper-container" v-if="url == 'about'">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in aboutList" :key='index' >
						<img :src="imageHttp(item.images) " />
					</div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
		</div>
		<!-- 移动端样式 -->
		<div class="phone_swiper">
			<div class="swiper-container" v-if="url == 'home'">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in homeList" :key='index'>
						<img :src="imageHttp(item.images) " />
					</div>
					<div class='modular' @click="open()"></div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
			<!-- 移动端产品服务 -->
			<div class="swiper-container" v-if="url == 'product'">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in productList" :key='index'>
						<img :src="imageHttp(item.images) " />
					</div>
					<div class='modular' @click="open()"></div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
			<!-- 渠道合作 -->
			<div class="swiper-container" v-if="url == 'channel '">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in channelList" :key='index' >
						<img :src="imageHttp(item.images) " />
					</div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
			<!-- 关于我们 -->
			<div class="swiper-container" v-if="url == 'about'">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in aboutList" :key='index' >
						<img :src="imageHttp(item.images) " />
					</div>
				</div>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
			</div>
		</div>
		<register v-show="registerShow" @change='open' @add='add'></register>
	</div>
	
</template>

<script>
	import { banner ,addClue} from '@/api'
	import { imageHttp } from '@/static/js/utils.js'
	import register from '@/components/register/index.vue'
export default {
	props:{
		bannerList:{
			type:Array,
			default:function(){
				return []
			}
		}
	},
	components:{
		register,
	},
  data() {
	return{
		url:'',
		type:'home_banner',
		homeList:[],
		productList:[],
		channelList:[],
		aboutList:[],
		registerShow:false,
	}
  },
  created() {
  	this.getBanner()
	this.getBannerBanner()
	this.getChannel()
	this.getAboutus()
  },
  mounted() {
	this.mySwiper()
  },
  watch:{
  	$route:{
  		handler(n,o){
  			if(n.fullPath == '/product'){
  				this.url = 'product'
  			}
  			if(n.fullPath == '/home'){
  				this.url = 'home'
  			}
			if(n.fullPath == '/channel'){
				this.url = 'channel'
			}
			if(n.fullPath == '/aboutUs'){
				this.url = 'about'
			}
  			
  		},
  		immediate: true,
  		deep: true
  	}
  },
  methods:{
	  imageHttp,
	  // 获取首页banner图
	  getBanner(type){
		  banner({
			  unique:'home_banner',
		  }).then(res => {
			  if(res.code == 200){
				  this.homeList = res.data.list
				  console.log(res)
			  }
		  })
	  },
	  // 获取产品banner图
	  getBannerBanner(type){
	  		  banner({
	  			  unique:'product_service'
	  		  }).then(res => {
	  			  if(res.code == 200){
	  				  this.productList = res.data.list
	  				  console.log(res)
	  			  }
	  		  })
	  },
	  // 渠道合作
	  getChannel(type){
	  		  banner({
	  			  unique:'channel_banner'
	  		  }).then(res => {
	  			  if(res.code == 200){
	  				  this.channelList = res.data.list
	  				  console.log(res)
	  			  }
	  		  })
	  },
	  // 关于我们
	  getAboutus(type){
	  		  banner({
	  			  unique:'about_banner'
	  		  }).then(res => {
	  			  if(res.code == 200){
	  				  this.aboutList = res.data.list
	  				  console.log(res)
	  			  }
	  		  })
	  },
	//轮播图
	mySwiper(){
		new Swiper('.swiper-container', {
			loop: true, //无缝轮播
			effect : 'fade',
			// 如果需要分页器
			pagination: '.swiper-pagination',
			// 如果需要前进后退按钮
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			autoplay: 5000,
			
		});
	},
	open(){
		console.log('wewe')
		this.registerShow = !this.registerShow
	},
	add(data){
		addClue(data).then(res => {
			if(res.code == 200){
				this.$toast('操作成功');
				console.log(res)
				this.registerShow = false
			}else{
				this.$toast(res.msg);
			}
		})
	},
  }
}
</script>

<style scoped="scoped" lang="scss">
	.mySwiper{
		width: 100%;
		height: 100%;
		.pc_swiper{
			.swiper-container{
				width: 100%;
				height: 100%;
				position: relative;
				.swiper-slide{
					width: 100%;
					height: 100%;
					
					img{
						width: 100%;
						height: 5.6rem;
						// height: 4.07rem;
						// margin-top: 1rem;
					}
				
				}
				.swiper-pagination{
					top: 4rem;
				}
				.modular{
					width: 2.1rem;
					height: 0.7rem;
					// background: #ffffff;
					position: absolute;
					top: 3.2rem;
					left: 3.5rem;
					z-index: 99999;
				}
			}
		}
		.phone_swiper{
			display: none;
		}
	}
	/deep/.swiper-pagination-bullet-active{
		background: #FF9729;
	}
	
	@media (max-width:1206px){
		.mySwiper{
			.pc_swiper{
				display: none;
			}
			.phone_swiper{
				display: block;
				.swiper-container{
					width: 100%;
					height: 100%;
					.swiper-slide{
						width: 100%;
						height: 100%;
						img{
							width: 100%;
							height: 3rem;
							margin-top: 0rem;
						}
						
					}
					.swiper-pagination{
						// top: 0rem;
						display: none;
					}
					.modular{
						width: 2.1rem;
						height: 0.6rem;
						// background: #ffffff;
						position: absolute;
						top: 1.6rem;
						left: 1.6rem;
						z-index: 9;
					}
				}
			}
		}
	}
</style>
